import { Spinner } from '@radix-ui/themes';
import { useTopBar } from 'hooks/useTopBar';
import { Outlet } from 'react-router';
import { ThemeSidebar } from '../components/ThemeSidebar';
import { ThemeEditorProvider } from '../context/ThemeEditorProvider';
import { useThemeEditor } from '../hooks/useThemeEditor';

const ThemesPageContent = () => {
  const { isLoadingClients } = useThemeEditor();

  useTopBar({ stringTitle: 'Themes' });

  if (isLoadingClients)
    return (
      <div className="flex justify-center p-8">
        <Spinner size="3" />
      </div>
    );

  return (
    <div className="flex h-full w-full overflow-hidden bg-white">
      <ThemeSidebar />
      <Outlet />
    </div>
  );
};

export const ThemesPage = () => (
  <ThemeEditorProvider>
    <ThemesPageContent />
  </ThemeEditorProvider>
);
